
    import { defineComponent, PropType } from 'vue';
    import { Offer } from '@/apps/shared/models/offer';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import checkPricingService from '@/apps/shared/services/checkPricing-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import typesOptionsGroupService from '@/apps/shared/services/typesOptionsGroup-service';
    import theftQuotationService from '@/apps/shared/services/theftQuotation-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';

    export default defineComponent({
        components: {
            XBreadcrumb,
            WhatsApp
        },
        name: 'Offer',
        props: {
            offer: {
                type: Object as PropType<Offer>,
                required: false
            }
        },
        data() {
            return {
                premioMensual: null,
                coberturas: null,
                dataCovers: [],
                data: [],
                selectedValue: null,
                AmparoJson: null,
                QuotationJson: null,
                coverDescription: null,
                selectedPlan: null,
                dataQ: [],
                isOffer: false,
                offerVisible: true,
                col: 2,
                plansLength: null,
                breadcrumItems: [
                    { text: 'Inicio', path: '/movilidad' },
                    { text: 'Cotizador de Movilidad', path: '/movilidad/cotizarMovilidad' },
                    { text: 'Valor del Vehiculo', path: '/movilidad/valorVehiculo' },
                    { text: 'Elegi Plan', path: '/valorVehiculo/elegiPlan' }
                ],
                tabOneWelcome: null,
                dataVehicle: null,
                rangeSelected: null,
                leadId: null,
                referente: null,
                medium: null,
                productId: 936,
                onDate: new Date().toISOString()
            };
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Movilidad urbana';
                const actualPath = '/movilidad';
                const actualStep = this.offer ? 'stepOffer' : 'quoted';

                const request = new SaveMultiQuoteNotificationsRequest();
                request.lastName = this.tabOneWelcome.lastName;
                request.firstName = this.tabOneWelcome.firstName;
                request.phone = this.tabOneWelcome.areaCode + this.tabOneWelcome.telephone;
                request.mail = this.tabOneWelcome.email;
                request.quotePlan = (this.AmparoJson ?? []).map((plan: any) => plan?.planDescription).filter(Boolean).join(' - ');
                request.quotationDetail = "Producto: " + defaultTitle
                    + " - Vehículo: " + this.dataVehicle.productDescription
                    + " - Valor: " + this.rangeSelected.productDescription;

                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, request);
                } catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultUrbanMobilityGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            volver() {
                sessionStorage.setItem('pressBack', 'true');
                this.$router.push({ name: 'movilidad-range-view' });
            },
            open: function () {
                this.$refs.modal.open();
            },
            close: function () {
                this.$refs.modal.close();
            },
            selectedPlans(quotationData: any, idx?: number) {
                sessionStorage.setItem('PlanSelected', JSON.stringify(quotationData));

                if (this.offer && idx !== undefined) {
                    const settings = JSON.parse(this.offer.OffersSettings || '{}');

                    const ranges = Array.isArray(settings?.CapitalRangeCode) ? settings.CapitalRangeCode : [];
                    const rangeCode = (ranges[idx] ?? ranges[0] ?? 1);

                    const productValueSelected = {
                        productDescription: `Rango ${rangeCode}`,
                        code: Number(rangeCode),
                        fromTab: 'tab-three'
                    };

                    this.rangeSelected = productValueSelected;

                    sessionStorage.removeItem('ProductValueSelected');
                    sessionStorage.setItem('ProductValueSelected', JSON.stringify(productValueSelected));
                }

                const pricingId = Array.isArray(quotationData?.PricingId)
                    ? Number(quotationData.PricingId[0])
                    : Number(quotationData?.PricingId);

                checkPricingService.checkStatePricing(pricingId).then((response: any) => {
                    if (response.errorMessage == 'Actualizacion correcta') {
                        this.$router.push({ name: 'UrbanMobilityClientData' });
                    } else {
                        const eventData = {
                            pas: null,
                            email: JSON.parse(sessionStorage.getItem('TabOneWelcome')).email,
                            product: 'movilidad',
                            event: 'errorServidor',
                            paso: 'cotizador-movilidad-plan',
                            referente: this.referente,
                            medio: this.medium
                        };

                        window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                        window.globalThis.dataLayer.push(eventData);

                        const customWindow = window as typeof window & {
                            _qsie?: Array<typeof eventData>;
                        };

                        customWindow._qsie ??= [];
                        customWindow._qsie.push(eventData);
                    }
                });
            },

            showError(errorMessage) {
                NF.Notification.show({
                    type: NF.Notification.Type.ERROR,
                    title: 'Error',
                    content: errorMessage,
                    position: NF.Notification.Positions.TOP_RIGHT,
                    clickClose: true,
                    autoHideDelay: 0
                });
            },

            dataAmparos() {
                this.dataQ = [];
                var AmparosData = sessionStorage.getItem('ResponseAmparos');
                var DataQuotation = sessionStorage.getItem('DataQuotation');

                if (AmparosData != null) {
                    this.AmparoJson = JSON.parse(AmparosData);
                    this.plansLength = this.AmparoJson.length;
                    this.QuotationJson = JSON.parse(DataQuotation);

                    if (this.offer) {
                        const firstQuote = Array.isArray(this.QuotationJson) ? this.QuotationJson[0] : null;
                        const mobilityTypeDesc = this.dataVehicle.productDescription ?? this.dataVehicle.productDescription ?? null;

                        const current = this.dataVehicle || JSON.parse(sessionStorage.getItem('ProductDataSelected')) || {};
                        const productDataSelected = {
                            productDescription: mobilityTypeDesc,
                            code: current?.code,
                            fromTab: current?.fromTab ?? 'tab-two'
                        };

                        this.dataVehicle = productDataSelected;
                        sessionStorage.setItem('ProductDataSelected', JSON.stringify(productDataSelected));
                    }

                    this.QuotationJson.forEach(({ plans, relationId, quotationId }: any) => {
                        const { finallyCalculationResult, premioMensual, premiumWithoutDiscount, discounts, premioSegunVigencia, pricingId } = plans[0];
                        this.dataQ.push({
                            finallyCalculationResult,
                            premioMensual,
                            premiumWithoutDiscount:
                                premiumWithoutDiscount &&
                                premiumWithoutDiscount.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
                            rate: discounts ? discounts[0].rate : null,
                            premioSegunVigencia,
                            PricingId: pricingId,
                            RelationId: relationId,
                            QuotationId: quotationId
                        });
                    });

                    for (var i = 0; i < this.AmparoJson.length; i++) {
                        var groupOfAmparoTheftOptions = [];
                        Object.assign(this.AmparoJson[i], this.dataQ[i])
                        var value = JSON.parse(JSON.stringify(this.AmparoJson[i]));
                        value.amparoTheftOptions.forEach(({ amparoTypes, amparoTypesDescription, capital, amparoTypesNotes }) => {
                            if (!groupOfAmparoTheftOptions.some(resp => resp.amparoTypes === amparoTypes)) {
                                groupOfAmparoTheftOptions.push({
                                    amparoTypes,
                                    coverDescription: amparoTypesDescription,
                                    capital: parseFloat(capital.toString().replace(/\./g, '')).toLocaleString('de-DE', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0
                                    }),
                                    amparoTypesNotes
                                });
                            }
                        });
                        const amparo = this.AmparoJson[i];

                        amparo.groupOfAmparoTheftOptions = groupOfAmparoTheftOptions;

                        amparo.value = { ...amparo };
                        this.coberturas = groupOfAmparoTheftOptions;
                        amparo.premioMensual = parseFloat(amparo.premioMensual.toString().replace(/\./g, '')).toLocaleString('de-DE', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        });
                    }
                } else {
                    // Revisar mensaje de error y poner el indicado por negocio
                    var errorMessage = 'No existen planes cotizables para los productos seleccionados';
                    this.showError(errorMessage);
                }
            },
            getMobilityTipoBienDescription(id) {
                const TecnologiaTipoBienDescription = {
                    1: "Bicicleta",
                    2: "Monopatín",
                    3: "Otros"
                };
                return TecnologiaTipoBienDescription[id] || "";
            },

            InitTabsOffer() {
                var OffersSettings = JSON.parse(this.offer!.OffersSettings);

                this.tabOneWelcome = {
                    firstName: 'aaa',
                    lastName: 'bbb',
                    areaCode: '',
                    telephone: '',
                    email: ''
                };
                sessionStorage.setItem('TabOneWelcome', JSON.stringify(this.tabOneWelcome));

                const productDataSelected = {
                    productDescription: this.getMobilityTipoBienDescription(OffersSettings.ProductDataSelectedCode),
                    code: OffersSettings.ProductDataSelectedCode,
                    fromTab: 'tab-two'
                };

                this.dataVehicle = productDataSelected;
                sessionStorage.setItem('ProductDataSelected', JSON.stringify(productDataSelected));

                const firstRangeCode = Array.isArray(OffersSettings?.CapitalRangeCode) ? OffersSettings.CapitalRangeCode[0] : 1;

                const productValueSelected = {
                    productDescription: `Rango ${firstRangeCode}`,
                    code: firstRangeCode,
                    fromTab: 'tab-three'
                };

                this.rangeSelected = productValueSelected;
                sessionStorage.setItem('ProductValueSelected', JSON.stringify(productValueSelected));
            },

            async getOfferUrbanMobilityQuotesAligned() {
                const settings = JSON.parse(this.offer!.OffersSettings || '{}');

                const ranges = Array.isArray(settings?.CapitalRangeCode) ? settings.CapitalRangeCode : [];
                const plans = Array.isArray(settings?.Plans) ? settings.Plans : [];

                const mobilityTypeId = Number(settings?.ProductDataSelectedCode ?? 0);

                const count = Math.min(ranges.length, plans.length);

                sessionStorage.removeItem('ResponseAmparos');
                sessionStorage.removeItem('DataQuotation');

                const responseAmparos = [];
                const dataQuotation = [];

                for (let x = 0; x < count; x++) {
                    const capitalRangeCode = Number(ranges[x]);
                    const planName = String(plans[x]);

                    const plansResponse = await typesOptionsGroupService.getTypesOptionsGroup(
                        this.productId, // 936
                        '',
                        capitalRangeCode,
                        this.onDate,
                        '',
                        '',
                        '',
                        ''
                    );

                    if (!Array.isArray(plansResponse)) {
                        this.showError(`TypesOptionsGroup inválido para x=${x} (capitalRangeCode=${capitalRangeCode})`);
                        continue;
                    }

                    const selectedPlan = (plansResponse as any[]).find((p: any) => p?.planDescription === planName);


                    if (!selectedPlan) {
                        this.showError(`No se encontró el plan "${planName}" para x=${x} (capitalRangeCode=${capitalRangeCode})`);
                        continue;
                    }

                    const amparosRaw = (selectedPlan)?.amparoTheftOptions;
                    const amparos = Array.isArray(amparosRaw) ? amparosRaw : amparosRaw ? [amparosRaw] : [];

                    if (amparos.length === 0) {
                        this.showError(`El plan "${planName}" no tiene amparos para x=${x} (capitalRangeCode=${capitalRangeCode})`);
                        continue;
                    }

                    var coverCustomizations = [];
                    var amparoTheftOptions = [];

                    amparos.forEach(opt => {
                        coverCustomizations.push({
                            coverNumber: opt.coverCode,
                            capital: opt.capital ?? 0,
                            deductibleType: 0,
                            rate: 0
                        });

                        amparoTheftOptions.push({
                            coverCode: opt.coverCode,
                            amparoTypes: opt.amparoTypes,
                            amparoOption: opt.amparoOption,
                            capital: opt.capital,
                            amparoTypesDescription: opt.amparoTypesDescription
                        });
                    });

                    const body = JSON.stringify({
                        userName: '',
                        userToken: '',
                        tokenType: '',
                        correlationInformation: '',
                        originRequest: '2',
                        coverCustomizations,
                        clientIdentify: {
                            documentType: 'D',
                            documentNumber: 0
                        },
                        quotationId: null,
                        relationId: null,
                        amparoTheftOptions,
                        mobilityTypeId
                    });

                    const quotation = await theftQuotationService.createTheft936Quotation(body);

                    responseAmparos.push({
                        planDescription: (selectedPlan).planDescription,
                        amparoTheftOptions: amparos
                    });

                    dataQuotation.push({
                        plans: quotation.plans,
                        quotationId: quotation.quotationId,
                        relationId: quotation.relationId,

                        mobilityTypeDesc: this.dataVehicle.productDescription
                    });

                    sessionStorage.setItem('ResponseAmparos', JSON.stringify(responseAmparos));
                    sessionStorage.setItem('DataQuotation', JSON.stringify(dataQuotation));
                }
            },

            async getInitData() {
                sessionStorage.setItem('ExitOrContinueModal', 'true');

                if (this.offer) {
                    await this.getOfferUrbanMobilityQuotesAligned();
                    this.dataAmparos();

                    this.offerVisible = true;

                    window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                    sessionStorage.removeItem('pressBack');
                    return;
                } else {
                    this.tabOneWelcome = JSON.parse(sessionStorage.getItem('TabOneWelcome'));
                    this.dataVehicle = JSON.parse(sessionStorage.getItem('ProductDataSelected'));
                    this.rangeSelected = JSON.parse(sessionStorage.getItem('ProductValueSelected'));
                    this.leadId = JSON.parse(sessionStorage.getItem('LeadId'));

                    const additionalInformation = {
                        Producto: this.dataVehicle.productDescription,
                        'Suma asegurada': this.rangeSelected.productDescription
                    };

                    CRMCotizadorWebService.CreateOrEditLead(
                        this.leadId,
                        this.tabOneWelcome.email,
                        location.href,
                        this.tabOneWelcome.areaCode,
                        this.tabOneWelcome.telephone,
                        936,
                        false,
                        '4',
                        additionalInformation,
                        this.tabOneWelcome.lastName,
                        this.tabOneWelcome.firstName
                    );

                    this.dataAmparos();

                    const eventData = {
                        pas: null,
                        email: this.tabOneWelcome.email,
                        product: 'movilidad',
                        event: 'cotizador-movilidad-valor',
                        referente: this.referente,
                        medio: this.medium
                    };

                    window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                    window.globalThis.dataLayer.push(eventData);

                    const customWindow = window as typeof window & {
                        _qsie?: Array<typeof eventData>;
                    };

                    customWindow._qsie ??= [];
                    customWindow._qsie.push(eventData);

                    sessionStorage.removeItem('pressBack');

                    var fromTabThree = sessionStorage.getItem('FromTabThree');
                    var fromTabFour = sessionStorage.getItem('FromTabFour');
                    if (fromTabThree == 'true' && fromTabFour == 'true') {
                        sessionStorage.setItem('FromTabThree', 'false');
                    } else {
                        sessionStorage.setItem('FromTabThree', 'false');
                        sessionStorage.setItem('FromTabFour', 'true');
                    }
                }
            }
        },

        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                var medium = sessionStorage.getItem("Medium");
                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                if (this.offer) {
                    this.offerVisible = false;

                    NF.UI.Page.block({
                        message: [
                            { text: 'Estamos buscando tu mejor cotización.', spin: '<i class="fa fa-asterisk fa-spin fa-3x"></i>' },
                            { text: 'Aquí viene el segundo mensaje', spin: '<i class="fa fa-circle-o-notch fa-spin fa-3x"></i>' },
                            { text: 'Este es el tercer y último mensaje de la serie', spin: '<i class="fa fa-asterisk fa-spin fa-3x"></i>' }
                        ]
                    });

                    const rutaAlternativa = sessionStorage.getItem('rutaAlternativa');

                    sessionStorage.removeItem('ResponseAmparos');
                    sessionStorage.removeItem('DataQuotation');
                    sessionStorage.removeItem('PlanSelected');

                    this.isOffer = true;
                    await this.InitTabsOffer();

                    await this.pageCustomization();
                    await DiscountRangeService.getUrbanMovilityDiscountRange();

                    if (rutaAlternativa != null) sessionStorage.setItem('rutaAlternativa', rutaAlternativa);

                    await this.getInitData();
                    await this.updateByProductGoogleAnalytics();
                } else {
                    NF.UI.Page.block();

                    await this.getInitData();

                    const parallelPromises = [this.pageCustomization(), this.updateByProductGoogleAnalytics()];
                    await Promise.all([...parallelPromises]);
                }
            } finally {
                NF.UI.Page.unblock();
            }
        }
    });
